const $khttp = require('./khttp');
const $kutil = require('./kutil');

const $kspace={
	list2json:function(array){
		try{
			if(array==null || array==undefined){
				return "";
			}
			return JSON.stringify(array);
		}catch(e){
			return "";
		}
	},
	json2string:function(jsonobj){
		try{
			if(jsonobj==null || jsonobj==undefined){
				return "";
			}
			return JSON.stringify(jsonobj);
		}catch(e){
			return "";
		}
	},
	sync:{
		spacerecycled: function(path){
			var apiserver = $kutil.getspaceapiurl(path);			
			return $khttp.postSync(apiserver,{"op":"spacerecycled"});
		},	
		getnodes:function(paths){
			var apiserver = $kutil.getspaceapiurl(paths[0]);
			return $khttp.postSync(apiserver,{"op":"kgetnodes","paths":$kspace.list2json(paths)});
		},	
		getnode:function(path){
			var apiserver = $kutil.getspaceapiurl(path);			
			try{
				return $khttp.postSync(apiserver,{"op":"kgetnodes","paths":$kspace.list2json([path])})[0];
			}catch(e){
				return {};
			}
		},
		listdir:function(dirpath, hasfile, hasdir, depth){
			var apiserver = $kutil.getspaceapiurl(dirpath);
			return $khttp.postSync(apiserver, {"op":"klistdir","dirpath":dirpath,"depth":depth,"hasdir":hasdir,"hasfile":hasfile});
		},
		askdownload:function(filepath, datahash,downfilename, downmimetype, expiredsecond,  policy){
			var apiserver = $kutil.getspaceapiurl(filepath);
			var data = {"op":"kaskdownload","filepath":filepath,"expiredsecond":expiredsecond,"downfilename":downfilename,"policy":$kspace.list2json(policy),
				"downmimetype":downmimetype,"datahash":datahash};		
			return $khttp.postSync(apiserver,data);
		},
		//申请上传令牌, 返回 {uptoken, upmethod, httpurl, httpheaders, httpmultiforms, partnumber, partminsize, partmaxsize, datasrv, expiredtime}
		//filemd5_optional/filesize_optional--本地文件MD5及大小(chunksize<0则为可选参数, 否则是必填参数)
		//chunksize--分片大小(-1表示不分片一次性上传)
		//expiredSecond--令牌过期时间
		//hopesrvs--优选的上传数据服务器
		askupload:function(filepath, filemd5,filesize, chunksize, expiredSecond, policy){
			var apiserver = $kutil.getspaceapiurl(filepath);
			return $khttp.postSync(apiserver,{"op":"kaskupload","filepath":filepath,"filemd5":filemd5,"filesize":filesize,
				"chunksize":chunksize,"expiredSecond":expiredSecond,"policy":$kspace.list2json(policy)});
		},
		mkdirs:function(dirpath,metamap){		
			var apiserver = $kutil.getspaceapiurl(dirpath);
			return $khttp.postSync(apiserver,{"op":"domkdirs","dirpath":dirpath,"metamap":$kspace.list2json(metamap)});
		},
		delete:function(path){
			return $kspace.sync.deletes([path]);
		},
		deletes:function(paths){
			var apiserver = $kutil.getspaceapiurl(paths[0]);
			return $khttp.postSync(apiserver,{"op":"dodeletes","paths":$kspace.list2json(paths)});
		},
		//兑换分片上传对象, 返回 {uptoken, upmethod, httpurl, httpheaders, httpmultiforms, partnumber, partminsize, partmaxsize, datasrv, expiredtime}
		exchangeupload:function(filepath, uptoken, partnumber){
			var apiserver = $kutil.getspaceapiurl(filepath);
			return $khttp.postSync(apiserver, {"op":"kexchangeupload","uptoken":uptoken,"partnumber":partnumber});
		},
		//查询已上传分片，返回 [{uptoken, partnumber(long), partmd5, partsize(long)}]
		queryuploaded:function(filepath, uptoken){
			var apiserver = $kutil.getspaceapiurl(filepath);
			return $khttp.postSync(apiserver, {"op":"kqueryuploaded","uptoken":uptoken});
		},
		//递交上传令牌(若文件已存在则覆盖它)
		submitupload:function(filepath, uptoken, metamap){
			var apiserver = $kutil.getspaceapiurl(filepath);
			return $khttp.postSync(apiserver,{"op":"ksubmitupload","filepath":filepath,"uptoken":uptoken,"meta":metamap});
		},
		doputfiles:function(apiserver,nodes){
			return $khttp.postSync(apiserver,{"op":"doputfiles","filenodes":$kspace.list2json(nodes)});
		},
		moves:function(apiserver,srcpaths, destpaths,metamap){
			return $khttp.postSync(apiserver,{"op":"domoves","srcpaths":$kspace.list2json(srcpaths),"destpaths":$kspace.list2json(destpaths),"meta":metamap});
		},
		thumbnails:function(filepaths){
			var apiserver = $kutil.getspaceapiurl(filepaths[0]);
			return $khttp.postSync(apiserver,{"op":"kthumbnails","filepaths":$kspace.list2json(filepaths)});
		},
		// 锁定文件
		lockfile: function(filepath, locktype){
			var apiserver = $kutil.getspaceapiurl(filepath);
			return $khttp.postSync(apiserver,{"op":"lockfile","filepath":filepath,"locktype": locktype});
		},
		// 解锁文件
		unlockfile: function(filepath){
			var apiserver = $kutil.getspaceapiurl(filepath);
			return $khttp.postSync(apiserver,{"op":"unlockfile","filepath":filepath});
		},
		//全局查询文件--根据cnum
		globalQuerycnums:function(cnums){
			return $khttp.postSync("/kabala",{"op":"globalquerycnums","cnums":$kspace.list2json(cnums)});
		},
	},
	//获取一组节点数组信息，必须为同一app下
	getnodes:function(paths){
		var apiserver = $kutil.getspaceapiurl(paths[0]);
		return $khttp.post(apiserver,{"op":"kgetnodes","paths":$kspace.list2json(paths)});
	},
	//获取一个空间路径的信息
	getnode:function(path){
		return $kspace.getnodes([path]);
	},
	// 统计文件夹
	statdir: function( dirpath , depth ){
		var apiserver = $kutil.getspaceapiurl(dirpath);
		return $khttp.post(apiserver,{"op":"kstatdir","dirpath":dirpath,"depth":depth});
	},
	//获取指定节点信息, 返回 [{path, isfile, meta, cnum, mnum, datahash, datasize, datawnum, dataversions, diricon}]
	listdir:function(dirpath, hasfile, hasdir,limit,pagepath,sortfield,sortasc,simplifynode){
		var apiserver = $kutil.getspaceapiurl(dirpath);
		return $khttp.post(apiserver, {"op":"klistdir","dirpath":dirpath,"hasdir":hasdir,"hasfile":hasfile,"limit":limit,"pagepath":pagepath,"sortfield":sortfield,"sortasc":sortasc,"simplifynode":simplifynode});
	},
	//列出文件夹的一级子文件夹, 以及子节点个数, 返回: [{path, subdircount, subfilecount, diricon}]
	treedir:function(dirpath){
		var apiserver = $kutil.getspaceapiurl(dirpath);
		return $khttp.post(apiserver,{"op":"ktreedir","dirpath":dirpath})
	},
	//根据关键词搜索匹配的文件, 返回 [{path, isfile, meta, cnum, mnum, {datahash, datasize, datawnum}, dataversions[{datahash, datasize, datawnum}] }]
	//String dirpaths--文件夹范围
	//queryterm--查询条件
	//int depth--查询深度
	//int limit--分页数量
	queryfiles:function(dirpath, queryterm, depth, limit, pagepath, sortfield, sortasc, simplifynode){		
		var apiserver = $kutil.getspaceapiurl(dirpath);
		return $khttp.post(apiserver,{"op":"kqueryfiles","dirpath":dirpath,"queryterm":queryterm, "depth":depth,"limit":limit,"pagepath":pagepath,"sortfield":sortfield,"sortasc":sortasc,"simplifynode":simplifynode});
	},
	querydirs:function(dirpath, queryterm, depth, limit){
		var apiserver = $kutil.getspaceapiurl(dirpath);
		return $khttp.post(apiserver,{"op":"kquerydirs","dirpath":dirpath,"queryterm":queryterm, "depth":depth,"limit":limit});
	},
	///批量获取高亮内容, 返回 [{filepath, highlight}]
	//[] filepaths
	//[] words
	highlights:function(filepaths,words){
		var apiserver = $kutil.getspaceapiurl(filepaths[0]);
		return $khttp.post(apiserver,{"op":"khighlights","filepaths":$kspace.list2json(filepaths),"highlightwords":$kspace.list2json(words)});
	},
	//申请下载地址url
	//string require path			路径
	//string option  downfilename	下载名称
	//string option  downmimetype	下载类型
	//int	 option	 expiredsecond	令牌过期日
	//string option	 datahash		下载的MD5
	//int[]  option  hopesrvs		优先的数据服务器
	askdownload:function(filepath, datahash,downfilename, downmimetype, expiredsecond,  hopesrvs){
		var apiserver = $kutil.getspaceapiurl(filepath);
		return $khttp.post(apiserver,{"op":"kaskdownload","filepath":filepath,"expiredsecond":expiredsecond,"downfilename":downfilename,"hopesrvs":$kspace.list2json(hopesrvs),
			"downmimetype":downmimetype,"datahash":datahash});
	},
	//申请上传令牌, 返回 {uptoken, upmethod, httpurl, httpheaders, httpmultiforms, partnumber, partminsize, partmaxsize, datasrv, expiredtime}
	//filemd5_optional/filesize_optional--本地文件MD5及大小(chunksize<0则为可选参数, 否则是必填参数)
	//chunksize--分片大小(-1表示不分片一次性上传)
	//expiredSecond--令牌过期时间
	//hopesrvs--优选的上传数据服务器
	askupload:function(filepath, filemd5,filesize, chunksize, expiredSecond, hopesrvs){
		var apiserver = $kutil.getspaceapiurl(filepath);
		return $khttp.post(apiserver,{"op":"kaskupload","filepath":filepath,"filemd5":filemd5,"filesize":filesize,
			"chunksize":chunksize,"expiredSecond":expiredSecond,"hopesrvs":$kspace.list2json(hopesrvs)});
	},
	//兑换分片上传对象, 返回 {uptoken, upmethod, httpurl, httpheaders, httpmultiforms, partnumber, partminsize, partmaxsize, datasrv, expiredtime}
	exchangeupload:function(filepath, uptoken, partnumber){
		var apiserver = $kutil.getspaceapiurl(filepath);
		return $khttp.post(apiserver, {"op":"kexchangeupload","uptoken":uptoken,"partnumber":partnumber});
	},
	//查询上传进度, 返回 [{uptoken, partnumber, partmd5, partsize}]
	queryuploaded:function(filepath,uptoken){
		var apiserver = $kutil.getspaceapiurl(filepath);
		return $khttp.post(apiserver,{"op":"kqueryuploaded","uptoken":uptoken});
	},
	//递交上传令牌(若文件已存在则覆盖它)
	submitupload:function(filepath, uptoken, metamap){
		var apiserver = $kutil.getspaceapiurl(filepath);
		return $khttp.post(apiserver,{"op":"ksubmitupload","filepath":filepath,"uptoken":uptoken,"meta":metamap});
	},
	//创建文件夹(支持多层)
	mkdirs:function(dirpath,metamap){		
		var apiserver = $kutil.getspaceapiurl(dirpath);
		return $khttp.post(apiserver,{"op":"domkdirs","dirpath":dirpath,"meta":metamap});
	},
	//重命名节点
	rename:function(path,rename,metamap){
		var apiserver = $kutil.getspaceapiurl(path);
		return $khttp.post(apiserver,{"op":"dorename","path":path,"rename":rename,"meta":metamap});
	},
	delete:function(path){
		return $kspace.deletes([path]);
	},
	deletes:function(paths){
		var apiserver = $kutil.getspaceapiurl(paths[0]);
		return $khttp.post(apiserver,{"op":"dodeletes","paths":$kspace.list2json(paths)});
	},
	//批量移动(若目标文件已存在则覆盖)
	moves:function(apiserver,srcpaths, destpaths,metamap){
		return $khttp.post(apiserver,{"op":"domoves","srcpaths":$kspace.list2json(srcpaths),"destpaths":$kspace.list2json(destpaths),"meta":metamap});
	},	
	copys:function(apiserver,srcpaths, destpaths,metamap){
		return $khttp.post(apiserver,{"op":"docopies","srcpaths":$kspace.list2json(srcpaths),"destpaths":$kspace.list2json(destpaths),"meta":metamap});
	},	
	doputfiles:function(apiserver,nodes){
		return $khttp.post(apiserver,{"op":"doputfiles","filenodes":$kspace.list2json(nodes)});
	},	
		
	//设置文件属性
	setmeta:function(path,metamap){
		var apiserver = $kutil.getspaceapiurl(path);
		return $kspace.setmetas([path],metamap);
	},	
	//设置文件属性
	setmetas:function(paths,metamap){
		var apiserver = $kutil.getspaceapiurl(paths[0]);
		return $khttp.post(apiserver,{"op":"dosetmetas","paths":$kspace.list2json(paths),"meta":$kspace.json2string(metamap)});
	},
	doremoveversions:function(filepath,versions,metamap){
		var apiserver = $kutil.getspaceapiurl(filepath);
		return $khttp.post(apiserver,{"op":"doremoveversions","filepath":filepath,"versions":$kspace.list2json(versions),"meta":metamap});
	},
	thumbnails:function(filepaths){
		var apiserver = $kutil.getspaceapiurl(filepaths[0]);
		return $khttp.post(apiserver,{"op":"kthumbnails","filepaths":$kspace.list2json(filepaths)});
	},
	// TODO
	askviewurl:function(filepath,datahash_optional,expiredseconds,policy){
		var apiserver = $kutil.getspaceapiurl(filepath);
		return $khttp.post(apiserver,{"op":"kaskviewurl","filepath":filepath,"datahash":datahash_optional,"expiredseconds":expiredseconds,"policy":policy?$kspace.json2string(policy):''});
	},
	// TODO
	askediturl:function(filepath, datahash, expiredseconds,policy){
		var apiserver = $kutil.getspaceapiurl(filepath);
		return $khttp.post(apiserver,{"op":"askediturl","filepath":filepath,"datahash":datahash,"policy":policy?$kspace.json2string(policy):''});
	},
	askpdfdownload:function(filepath, datahash, timeoutseconds,policy){
		var apiserver = $kutil.getspaceapiurl(filepath);
		return $khttp.post(apiserver,{"op":"askpdfdownload","filepath":filepath,"datahash":datahash,"timeoutseconds":timeoutseconds,"policy":policy?$kspace.json2string(policy):''});
	},
	//在线压缩文件返回download对象
	askzipdownloads:function(filepaths,downfilename,timeoutseconds,charset){
		var apiserver = $kutil.getspaceapiurl(filepaths[0]);
		return $khttp.post(apiserver,{"op":"askzipdownloads","paths":$kspace.list2json(filepaths),"downfilename":downfilename,"timeoutseconds":timeoutseconds,"charset":charset});
	},	
	askfulltext:function(filepath, datahash){
		var apiserver = $kutil.getspaceapiurl(filepath);
		return $khttp.post(apiserver,{"op":"kaskfulltext", "filepath":filepath, "datahash":datahash});
	},
	//在线解压文件到指定目录
	// askunzipfiles: function(filepath,datahash,destpath,timeout){
	// 	var apiserver = $kutil.getspaceapiurl(filepath);
	// 	return $khttp.post(apiserver,{"op":"askunzipfiles","filepath":filepath,"datahash":datahash,"destpath":destpath,"timeoutseconds":timeout});
	// },

	joblaunch: function(filepath,datahash,destpath,timeoutseconds,jobtype,jobparams,await){
		var apiserver = $kutil.getspaceapiurl(filepath);
		return $khttp.post(apiserver,{"op":"joblaunch","filepath":filepath,"datahash":datahash,"destpath":destpath,"timeoutseconds":timeoutseconds,"jobtype":jobtype,"jobparams":JSON.stringify(jobparams),"await":await});
	},
	//设置标签OR移除标签
	dosettags:function(paths,savetags,removetags){
		var apiserver = $kutil.getspaceapiurl(paths[0]);
		return $khttp.post(apiserver,{"op":"dosettags","paths":$kspace.list2json(paths),"savetags":$kspace.list2json(savetags),"removetags":$kspace.list2json(removetags)});
	},	
	// 设置版本Meta
	dosetversionmeta: function(filepath, version, meta){
		var apiserver = $kutil.getspaceapiurl(filepath);
		return $khttp.post(apiserver,{"op":"dosetversionmeta","filepath":filepath,"version":version,"meta":meta});
	},
	// 锁定文件
	lockfile: function(filepath,locktype){
		var apiserver = $kutil.getspaceapiurl(filepath);
		return $khttp.post(apiserver,{"op":"lockfile","filepath":filepath,"locktype":locktype});
	},
	// 解锁文件
	unlockfile: function(filepath){
		var apiserver = $kutil.getspaceapiurl(filepath);
		return $khttp.post(apiserver,{"op":"unlockfile","filepath":filepath});
	},
	// 移动端查询一批文件可执行操作
	queryviewops: function(paths){
		var apiserver = $kutil.getspaceapiurl(paths[0]);
		return $khttp.post(apiserver,{"op":"kqueryviewops", "paths":$kspace.list2json(paths) });
	},
	//全局查询文件--根据cnum
	globalquerycnums:function(cnums){		
		return $khttp.post("/kabala",{"op":"globalquerycnums","cnums":$kspace.list2json(cnums)});
	},
	//全局查询文件--根据查询条件
	globalqueryfiles:function(queryterm,simplifynode){		
		return $khttp.post("/kabala",{"op":"globalqueryfiles","queryterm":queryterm,"simplifynode":simplifynode});
	},
	//全局查询文件--查找相关文件，返回 [{linkid, linklabel, linkfiles[filenode1, filenode2, ...] }]
	globallinkfiles:function(filepath, linkid, linkcount, dirscope){
		return $khttp.post("/kabala",{"op":"globallinkfiles", "filepath":filepath, "linkid":linkid, "linkcount":linkcount, "dirscope":dirscope});
	},
	//全局查询文件--根据节点路径
	globalgetnodes:function(paths){
		return $khttp.post("/kabala",{"op":"globalgetnodes","paths":$kspace.list2json(paths)});
	},	
	//全局获取文件信息--高亮文本, 返回 [{filepath, highlight}]
	globalhighlights:function(filepaths,highlightwords){
		return $khttp.post("/kabala",{"op":"globalhighlights","filepaths":$kspace.list2json(paths),"highlightwords":$kspace.list2json(highlightwords)});
	},	
	//全局查询文件缩略图--根据节点路径, 返回 [{filepath, thumbnailurl}]
	globalthumbnailurl:function(paths){
		return $khttp.post("/kabala",{"op":"globalthumbnailurl","filepaths":$kspace.list2json(paths)});
	},
	//新建一个空的文件或从指定路径复制一个文件新建
	globalnewfile:function(dirpath, newname, filetype, datahash){
		return $khttp.post("/kabala",{"op":"globalnewfile", "dirpath":dirpath, "newname":newname, "filetype":filetype, "datahash":datahash});
	},
	
	getmetalinkable:function(node){	
		var result = [];
		if(node && node.metas){
			for(var i=0;i<node.metas.length;i++){
				if(node.metas[i].showlinkable){
					result.push(node.metas[i]);
				}
			}
		}
		return result;
	},
	// 获取文件摘要
	getmetatextsummary:function(node){				
		var result = [];
		try{
			var _des = [];
	    	for (var i = 0; i < node.metas.length; i++) {
	    		var _temp = node.metas[i];
	    		if( _temp.key && _temp.key.startWith("TEXTSUMMARY") ){
	    			_des.push({
	    				key: _temp.key,
	    				value: _temp.value,
	    			});
	    		}
	    	}
	    	if( _des && _des.length > 0 ){
	    		_des = $kutil.sortArray(_des, "key");
	    		if(_des){
	    			for (var i = 0; i < _des.length; i++) {
	    				result.push(_des[i].value);
	    			}
	    		}
	    	}
		}catch(err){			
		}
		return result;
	},
}

module.exports = $kspace;
